import {asyncActionsFactory} from '@wix/wix-events-commons-statics'
import {ControllerFlowAPI} from '@wix/yoshi-flow-editor'
import {CommonState, CommonStoreExtraArgs} from '../types/state'

export type CommonExtraArgs = CommonStoreExtraArgs & {flowAPI: ControllerFlowAPI}

export const createAsyncAction = asyncActionsFactory<CommonState, CommonExtraArgs>()
